<template>
	<v-container fluid class="planificationPrint" style="padding-top: 0;">
		<v-row>
			<div v-if="enableAdvancedPlanning" class="pa-0 d-print-none" style="width: 100%; margin-bottom: 10px;">
				<v-tabs v-model="tab" class="mx-auto" style="width: fit-content;">
					<v-tab>{{ $t('wkt.admin.projects.calendar.tab.monthly') }}</v-tab>
					<v-tab>{{ $t('wkt.admin.projects.calendar.tab.weekly') }}</v-tab>
				</v-tabs>
			</div>
			<v-col cols="12" class="pb-2 px-4 d-none d-print-block d-print-flex justify-space-between align-center">
				<span style="color: #000; font-size: 1.375em !important; font-weight: 500;">
					{{ printTitle() }}
				</span>
				<span style="color: #000; font-size: 18px; font-weight: 400;">
					{{ printPeriod() }}
				</span>
			</v-col>
			<v-col cols="12" class="pa-0">
				<v-tabs-items v-model="tab" style="background-color: transparent !important;">
					<v-tab-item eager>
						<ProjectCalendarMonthlyFilters 
							ref="monthlyCalendarFilters" 
							class="d-print-none" 
							@updated="onMonthlyFiltersUpdated($event)" />
						<CalendarWidget 
							ref="monthlyCalendar" 
							:view="0" 
							:type="0" 
							:onlyVacationData="false" 
							:showSummary="false" 
							:showTabs="enableAdvancedPlanning"
							class="d-print-flex" 
							@day-selected="onDaySelected($event)" 
							@alert-event="doShowAlert($event)" />
					</v-tab-item>
					<v-tab-item eager>
						<ProjectCalendarWeeklyFilters 
							ref="weeklyCalendarFilters" 
							class="d-print-none" 
							@updated="onWeeklyFiltersUpdated($event)" />
						<CalendarWidget 
							ref="weeklyCalendar" 
							:view="1" 
							:type="1" 
							:onlyVacationData="false" 
							:showSummary="false"
							:showTabs="enableAdvancedPlanning"
							class="d-print-flex" 
							@day-selected="onDaySelected($event)" 
							@alert-event="doShowAlert($event)" />
					</v-tab-item>
				</v-tabs-items>
			</v-col>
		</v-row>

		<!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
		<v-snackbar
		v-model="showAlert"
		:timeout="alertTimeout"
		:color="alertColor">
			<span style="color: #ffffff;">{{alertText}}</span>
			<v-btn text @click="showAlert=false">
			<span style="color: #ffffff;">Cerrar</span>
			</v-btn>
		</v-snackbar>
		<!-- FIN BLOQUE ESTADO PETICIONES -->

	</v-container>
</template>

<script>
import BaseModule from '../common/BaseModule';
import gwt from '../../api/gwt';
import CalendarWidget from '../common/calendar/CalendarWidget';
import ProjectCalendarMonthlyFilters from './projectcalendar/ProjectCalendarMonthlyFilters';
import ProjectCalendarWeeklyFilters from './projectcalendar/ProjectCalendarWeeklyFilters';
import { EventBus }  from '../util/event-bus';

export default {
  name: 'ProjectCalendarModule',
  mixins: [BaseModule],
  components: {
	CalendarWidget, ProjectCalendarMonthlyFilters, ProjectCalendarWeeklyFilters
  },
  data () {
      return { 
		tab: 0,
		currentYear: 0,
		currentMonth: 0,
		currentWeek: 0,
		enableAdvancedPlanning: false,
		showAlert: false,
		alertColor: 'error',
		alertText: '',
		alertTimeout: 3000,
      }
    },
	computed: {
	},
	methods: {
		doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
		onReveal() {
			if (!gwt.getSessionInformation()) {
				setTimeout(this.onReveal, 1000);
				return;
			}
    
            this.currentYear = this.getCurrentYear();
			this.currentMonth = this.getCurrentMonth();
			this.currentWeek = this.getCurrentWeek();

			const company = gwt.getSessionInformation().company;
			const startYear = new Date(company.creationDate).getFullYear();

			this.enableAdvancedPlanning = company.enableAdvancedPlanning;
				
			const calendars = gwt.getCalendars();
			let projects = gwt.getProjects();
			if (projects) {
				projects = projects.filter(p => p.projectType === 0); // --> Project.TYPE_PROJECT
			}

			const me = this;

			this.$nextTick(function() {
				me.$refs.monthlyCalendarFilters.init(startYear, me.currentYear, me.currentMonth);
				me.$refs.monthlyCalendar.init(me.currentYear, me.currentMonth, me.currentWeek, calendars, projects);

				if (me.enableAdvancedPlanning) {
					me.$refs.weeklyCalendarFilters.init(startYear, me.currentYear, me.currentWeek);
					me.$refs.weeklyCalendar.init(me.currentYear, me.currentMonth, me.currentWeek, calendars, projects);
				}
			});
		},  
		refreshModule() {
			this.$refs.monthlyCalendar.updateData();
				
			if (this.enableAdvancedPlanning) {
				this.$refs.weeklyCalendar.updateData();
			}
		},
		onMonthlyFiltersUpdated(filter) {
			this.$refs.monthlyCalendar.updateFilter(filter);
		},
		onWeeklyFiltersUpdated(filter) {
			this.$refs.weeklyCalendar.updateFilter(filter);
		},
		printTitle() {
			let title = this.$t('wkt.admin.projects.calendar.title');
			
			if (this.tab === 0) {
				return `${title} ${this.$t('wkt.admin.projects.calendar.tab.monthly').toLowerCase()}`;
			} else {
				return `${title} ${this.$t('wkt.admin.projects.calendar.tab.weekly').toLowerCase()}`;
			}
		},
		printPeriod() {
			if (!this.$refs || !this.$refs.monthlyCalendarFilters || !this.$refs.weeklyCalendarFilters) {
				return '';
			}

			if (this.tab === 0) {
				return this.$refs.monthlyCalendarFilters.getPeriod();
			} else {
				return this.$refs.weeklyCalendarFilters.getPeriod();
			}
		},
		onDaySelected(day) {
			if (!day.vacation) {
				EventBus.$emit('widget-data-click', { mode: '', type: 'WORKDAY', action: 'EDIT', payload: JSON.stringify(day) });
				return;
			}

			if (day.vacation.recordStatus !== 4) { //REQUEST_PROCESSED
				EventBus.$emit('widget-data-click', { mode: '', type: 'PROCEDURE', action: 'EDIT', payload: JSON.stringify(day) });
				return;
			}

			EventBus.$emit('widget-data-click', { mode: '', type: 'VACATION', action: 'EDIT', payload: JSON.stringify(day) });
		},
	},
}
</script>

<style scoped>
</style>

